import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export interface AlertRow {
  id: string;
  title: string;
  severity: "warn" | "critical";
  client: string | null;
  source: string;
  created_at: string;
}

export function useAlerts() {
  return useQuery({
    queryKey: ["alerts"],
    queryFn: async () => {
      const since = new Date(Date.now() - 24 * 3600 * 1000).toISOString();
      const { data, error } = await supabaseAgency
        .from("os_tasks").select("id,title,severity,client,source,created_at")
        .in("severity", ["warn", "critical"])
        .is("acknowledged_at", null)
        .gte("created_at", since)
        .order("created_at", { ascending: false });
      if (error) throw error;
      const rows = (data ?? []) as AlertRow[];
      return { rows, synced_at: rows[0]?.created_at ?? null };
    },
  });
}
